<template>
  <div>
    <title-edit header="Sponser program" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Orders* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.orders" @update="updateOrders"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Branch* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Title TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.title_th" @update="updateTitleTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Title EN* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-text-field :model="form.title_en" @update="updateTitleEN"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN"/>
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteSponserProgram"/>
      <preview-button />
      <save-button @click.native="saveSponserProgram"/>
    </div>
  </div>
</template>

<script>
    import TitleEdit from "../../../components/TitleHeader/TitleEdit";
    import LineHr from "../../../components/Icon/line-hr";
    import SelectOption from "../../../components/Input/selectOption";
    import DeleteButton from "../../../components/Button/DeleteButton";
    import PreviewButton from "../../../components/Button/PreviewButton";
    import SaveButton from "../../../components/Button/SaveButton";
    import InputTextField from "../../../components/Input/InputTextField";
    import InputEditor from "../../../components/Input/InputEditor";
    import {mapState} from "vuex";
    export default {
        name: "SponserProgramEdit",
      components: {
        InputEditor,
        InputTextField,
        SaveButton, PreviewButton, DeleteButton,
        SelectOption, LineHr, TitleEdit},
      computed: {
        ...mapState({
          form: state => {
            return state.SponserProgram.form;
          }
        })
      },
      data(){
          return {
            optionBranch : [],
          }
      },
      created() {
          this.getBranchData();
      },
      methods:{
        getBranchData() {
          this.$store.dispatch("Branch/getBranchAll").then(res => {
            this.optionBranch = [
              { text: "Select", value: "" },
              ...res.map(type => ({
                value: type.branch_id,
                text: type.branch_name_th + " (" + type.branch_name_en + ")"
              }))
            ];
          });
        },
        saveSponserProgram(){
          this.$store.dispatch("SponserProgram/saveSponserProgram",{
            id : this.form.id,
            data : this.form,
          }).then(res=>{
            if(res.response_code == 200){
              this.goToSponserTable();
            }
          }).catch(()=>{
            alert('cannot save Sponser program data');
          })
        },
        deleteSponserProgram(){
          this.$store.dispatch("SponserProgram/deleteSponserProgram",this.form.id).then(res=>{
            if(res.response_code == 200){
              this.goToSponserTable();
            }
          }).catch(()=>{
            alert('cannot delete Sponser program data');
          })
        },
        goToSponserTable(){
          this.$router.push("/about/sponser-program");
        },
        updateBranch(val){
          this.form.branch_id = val;
        },
        updateTitleTH(val){
          this.form.title_th = val;
        },
        updateTitleEN(val){
          this.form.title_en = val;
        },
        updateDescriptionTH(val){
          this.form.description_th = val;
        },
        updateDescriptionEN(val){
          this.form.description_en = val;
        },
        updateOrders(val){
          this.form.orders = val;
        },
      },
    }
</script>

<style scoped>

</style>
